import * as React from 'react';
import { Container, Header, Title, Content, View, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner } from 'native-base';
import { ImageBackground, Image } from 'react-native';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';

const pieImage = require('../../../assets/pie_chart.png');

import styles from './styles';
export interface Props {
	navigation: any;
	list: any;
}
export interface State {}

/*
If your React component’s render() function renders the same result given the same props and state, you can use React.PureComponent
for a performance boost in some cases.
*/

class Reports extends React.Component {
	render() {
		//should be a default OFFLINE list???
		const fakes = [{}, {}, {}, {}, {}];

		return (
			<Content>
				<Image source={require('../../../assets/pie_chart.png')} style={{ height: 120, width: '100%', resizeMode: 'contain', alignSelf: 'center' }} />

				<List>
					{this.props.list &&
						this.props.list.map((item, i) => (
							<ListItem
								key={i}
								style={{ marginHorizontal: 10 }}
								onPress={() => {
									if (item.report) {
										this.props.navigation.navigate({ name: 'Report', params: { report: item.report } });
									} else {
										this.props.navigation.navigate({ name: item.url });
									}
								}}>
								<Body style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
									<Text style={{ marginRight: 20, minWidth: 100 }}>{item.desc}</Text>
									{!!item.subtitle && (
										<Text note style={{ fontSize: 11, textAlignVertical: 'center', alignSelf: 'center' }}>
											{item.subtitle}
										</Text>
									)}
								</Body>
								<Right style={{ flex: 0 }}>
									<Icon name="arrow-forward" />
								</Right>
							</ListItem>
						))}
					{!this.props.list &&
						fakes.map((item, i) => (
							<ListItem key={i} style={{ marginHorizontal: 10 }}>
								<Body>
									<ShimmerPlaceHolder style={{ marginBottom: 10 }}>
										<Text>Test</Text>
									</ShimmerPlaceHolder>
								</Body>
								<Right>
									<Icon name="arrow-forward" />
								</Right>
							</ListItem>
						))}
				</List>
			</Content>
		);
	}
}

export default Reports;
